export default __webpack_public_path__ + "media/zurb/img/home/home-service-img1-9a5471b857080a9b14d0db9fd6ba9cd6.png";